module.exports = __webpack_public_path__ + "static/img/avatar_default.a632f8a5.png";